import { createSlice } from '@reduxjs/toolkit';

import { Service } from '@/types/service';
import * as asyncActions from './asyncActions';

type State = {
  items: Service[];
};

const initialState: State = {
  items: [],
};

const slice = createSlice({
  name: 'organization-service',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(asyncActions.fetchList.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
